export default "__VITE_ASSET__Oihx00Sh__"